import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import PropTypes from 'prop-types'
import {
    XIcon,
    DotsVerticalIcon,
    DotsHorizontalIcon,
} from '@heroicons/react/outline'
import Button from '../../../components/Button/Button'

const InstructionsForChromeModal = ({
    isOpen,
    setIsOpen,
    isDesktop,
    isChrome,
}) => {
    const closeModal = () => {
        setIsOpen(false)
    }

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-200"
                    onClose={closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-modalBackground bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-auto max-w-full transform overflow-hidden rounded-3xl bg-white md:p-12 p-6 text-center flex flex-col items-start justify-start transition-all relative gap-y-6">
                                    <XIcon
                                        className="w-4 h-4 stroke-current stroke-2 absolute text-textDarkerGray top-6 right-6 cursor-pointer"
                                        onClick={closeModal}
                                    />

                                    <Dialog.Title
                                        as="h3"
                                        className="mt-6 text-lg text-black90 font-semibold w-full text-center"
                                    >
                                        Instructions for{' '}
                                        {isChrome ? 'Chrome' : 'Edge'}
                                    </Dialog.Title>

                                    <p className="text-base text-black60 font-medium w-full text-center">
                                        Add a website icon to your{' '}
                                        {!isDesktop
                                            ? 'mobile home screen'
                                            : 'desktop'}
                                    </p>

                                    {isDesktop ? (
                                        <>
                                            <p className="text-textDarkGray text-left  text-base font-normal flex flex-row items-center justify-start">
                                                <b>1.</b> Click the menu button:{' '}
                                                {isChrome ? (
                                                    <DotsVerticalIcon className="w-6 h-6 ml-2 text-black90" />
                                                ) : (
                                                    <DotsHorizontalIcon className="w-6 h-6 ml-2 text-black90" />
                                                )}
                                            </p>

                                            <p className="text-textDarkGray text-left text-base font-normal">
                                                <b>2.</b>{' '}
                                                {isChrome
                                                    ? 'Scroll down the list of options, then click Cast, save, and share'
                                                    : 'Scroll down the list of options, then click Apps'}
                                            </p>

                                            <p className="text-textDarkGray text-left text-base font-normal">
                                                <b>3.</b>{' '}
                                                {isChrome
                                                    ? 'Click the option Install page as app..'
                                                    : 'Install LiftOne Now'}
                                            </p>

                                            <p className="text-textDarkGray text-left text-base font-normal">
                                                <b>4.</b> Choose a name for the
                                                new shortcut and click Install
                                            </p>
                                        </>
                                    ) : (
                                        <>
                                            <p className="text-textDarkGray text-left  text-base font-normal flex flex-row items-center justify-start">
                                                <b>1.</b> Tap the menu button:
                                                <DotsVerticalIcon className="w-6 h-6 ml-2 text-black90" />
                                            </p>

                                            <p className="text-textDarkGray text-left text-base font-normal">
                                                <b>2.</b> Scroll down the list
                                                of options, then tap Add to Home
                                                Screen
                                            </p>

                                            <p className="text-textDarkGray text-left text-base font-normal">
                                                <b>3.</b> Choose a name for the
                                                new shortcut and click Save
                                            </p>
                                        </>
                                    )}

                                    <Button
                                        text="Got it"
                                        className="w-full"
                                        onClick={() => {
                                            setIsOpen(false)
                                        }}
                                        variant="primary"
                                    />

                                    <p className="text-textDarkGray text-sm font-normal w-full text-center">
                                        Need assistance?{' '}
                                        <span
                                            className="text-links underline font-normal cursor-pointer"
                                            onClick={() =>
                                                (window.location =
                                                    'mailto:help@liftonenow.com')
                                            }
                                        >
                                            Contact Us
                                        </span>
                                    </p>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

InstructionsForChromeModal.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    isDesktop: PropTypes.bool,
    isChrome: PropTypes.bool,
}

export default InstructionsForChromeModal
